const clientFormValidation = (values) => {
  let errors = {};

  if (!values.name) {
    errors = {
      ...errors,
      name: "Client name is required",
    };
  }

  if (!values.code) {
    errors = {
      ...errors,
      code: "Client code is required",
    };
  }

  if (values.code && values.code.length > 4) {
    errors = {
      ...errors,
      code: "Client code cannot exceed 4 characters",
    };
  }

  if (values.code && values.code.length < 1) {
    errors = {
      ...errors,
      code: "Client code must be at least 1 character",
    };
  }

  if (values.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
    errors = {
      ...errors,
      email: "Please enter a valid email address",
    };
  }

  return errors;
};

export default clientFormValidation;

